<template>
  <base-zupu-details-page>
    <page-not-found slot="page-not-found"></page-not-found>
    <zupu-detail-page-header slot="header" slot-scope="props" :zupu="props.zupu"></zupu-detail-page-header>
    <template v-slot:info-cta>
      <translate-cta v-if="userIsSubscribedState"></translate-cta>
      <zupu-subscribe-cta v-else></zupu-subscribe-cta>
    </template>
  </base-zupu-details-page>
</template>

<script>
import BaseZupuDetailsPage from '@common/pages/zupuDetails/BaseZupuDetailsPage';
import {mapGetters} from 'vuex';

import PageNotFound from '@/components/page.not.found';

import TranslateCta from './TranslateCta';
import ZupuDetailPageHeader from './ZupuDetailPageHeader';
import ZupuSubscribeCta from './ZupuSubscribeCta';

export default {
  computed: {
    ...mapGetters(['userIsSubscribedState']),
  },
  components: {
    TranslateCta,
    ZupuSubscribeCta,
    ZupuDetailPageHeader,
    BaseZupuDetailsPage,
    PageNotFound,
  },
};
</script>

<style scoped lang="scss"></style>
